import exclusiveInterfaces from './interface';

const interfaces = window.API.wrap(exclusiveInterfaces, 'xhrNeo');

export default interfaces;
